import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import TimePicker from "@/common/elements/TimePicker";
import { StyledGridCol, StyledGridRow, StyledInformationList, StyledSectionHeading } from "@/common/styles";
import BookingAdministrativeInformation from "@/components/BookingsDetails/BookingAdministrativeInformation";

const TrainingClassForm = () => {
    return(
        <>
         <StyledSectionHeading marginTop="0px">
            <span>Staff Member Information</span>
         </StyledSectionHeading>

         
         <StyledInformationList style={{paddingLeft:"0px"}}>
           <h6 className="title">Personal Info</h6>

           <StyledGridRow gutter={20}>
                <StyledGridCol lg="auto">
                    <div className="list-item">
                        <div className="key">Last Name</div>
                        <div className="value">EHR-SYSTEM</div>
                   </div>
                </StyledGridCol>

                <StyledGridCol lg="auto">
                    <div className="list-item">
                        <div className="key">First Name</div>
                        <div className="value">INTERFACE</div>
                   </div>
                </StyledGridCol>

                <StyledGridCol lg="auto">
                    <div className="list-item">
                        <div className="key">Middle Name</div>
                        <div className="value">-</div>
                   </div>
                </StyledGridCol>

                <StyledGridCol lg="auto">
                    <div className="list-item">
                        <div className="key">Suffix</div>
                        <div className="value">-</div>
                   </div>
                </StyledGridCol>

           </StyledGridRow>
           
         </StyledInformationList>

         <StyledSectionHeading marginTop="0px">
            <span>Class Information</span>
         </StyledSectionHeading>
         
         <StyledGridRow gutter={16}>
            <StyledGridCol lg={8}>
                <FormItem label="Category">
                   <Select />
                </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={8}>
                <FormItem label="Class Name">
                   <TextField />
                </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={8}>
                <FormItem label="Instructor">
                   <TextField />
                </FormItem>
            </StyledGridCol>

         </StyledGridRow>
         
         <StyledGridRow gutter={16}>
           <StyledGridCol lg={8}>
                <FormItem label="Location">
                   <TextField />
                </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={4}>
                <FormItem label="Capacity">
                   <TextField />
                </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={4}>
                <FormItem label="Hours">
                   <TextField />
                </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={4}>
                <FormItem label="POST#">
                   <TextField />
                </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={4}>
                <FormItem label="POST Hours">
                   <TextField />
                </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={24}>
                <FormItem label="Description">
                   <TextField />
                </FormItem>
            </StyledGridCol>

         </StyledGridRow>

         <StyledGridRow gutter={16}>
           <StyledGridCol lg={16}>
                <h6>Scheduled Date / Times</h6>

                <StyledGridRow gutter={16}>
                   
                    <StyledGridCol lg={6}>
                       <FormItem label="Start Date">
                          <CommonDatePicker format="MM/DD/YYYY" showTime={false}/>
                       </FormItem>
                    </StyledGridCol>

                    <StyledGridCol lg={6}>
                       <FormItem label="End Date">
                          <CommonDatePicker format="MM/DD/YYYY" showTime={false}/>
                       </FormItem>
                    </StyledGridCol>

                    <StyledGridCol lg={6}>
                       <FormItem label="Start Time">
                          <TimePicker />
                       </FormItem>
                    </StyledGridCol>

                    <StyledGridCol lg={6}>
                       <FormItem label="End Time">
                          <TimePicker />
                       </FormItem>
                    </StyledGridCol>

                </StyledGridRow>

            </StyledGridCol>

            <StyledGridCol lg={8}>
                <h6>Completed</h6>
                <StyledGridRow gutter={16}>
                <StyledGridCol lg={10}>
                       <FormItem label="Date">
                          <CommonDatePicker format="MM/DD/YYYY" showTime={false}/>
                       </FormItem>
                </StyledGridCol>

                <StyledGridCol lg={12}>
                       <FormItem label="Expiration Days">
                          <TextField />
                       </FormItem>
                </StyledGridCol>
                </StyledGridRow>

            </StyledGridCol>

         </StyledGridRow>
         
         <StyledGridRow>
            <StyledGridCol lg={24}>
                <FormItem label="Attendee Comments">
                   <TextField inputType="textarea" rows="4" />
                </FormItem>
            </StyledGridCol>

         </StyledGridRow>

           
        <BookingAdministrativeInformation 
        showHeaderLabel 
        headerLabel="Administrative Information"
        showActionButton={false}/>
     
        </>
    )
}
export default TrainingClassForm;